import { useEffect, useState } from "react";

export const useRightSidebarState = () => {
  const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);
  const [isFirstMount, setIsFirstMount] = useState(true);

  useEffect(() => {
    // При первом монтировании читаем из localStorage
    const savedState = localStorage.getItem("rightSidebarOpen");
    if (savedState) {
      setIsRightSidebarOpen(JSON.parse(savedState));
    }
    setIsFirstMount(false);
  }, []);

  const setRightSidebarOpen = (value: boolean) => {
    if (!isFirstMount) {
      // Не сохраняем при первом рендере
      localStorage.setItem("rightSidebarOpen", JSON.stringify(value));
    }
    setIsRightSidebarOpen(value);
  };

  return [isRightSidebarOpen, setRightSidebarOpen] as const;
};
